export default "__VITE_ASSET__CNinh_rt__"